import { __awaiter, __generator } from 'tslib';

function questionnaireCheckbox(question) {
    var _this = this;
    return {
        id: question.text,
        component: 'magic-multiple-answer',
        isDataField: true,
        isStandAlone: true,
        preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        question: question,
                    }];
            });
        }); },
    };
}

export { questionnaireCheckbox };
